import { render, staticRenderFns } from "./HistoVersions.vue?vue&type=template&id=780b1608"
import script from "./HistoVersions.vue?vue&type=script&lang=js"
export * from "./HistoVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports